export const CLUBS = [
    { code: 'TENSSSXS', name: '1066 Swimmers' },
    { code: 'ENTXSEDX', name: '1930 ASC' },
    { code: 'FRSSONBS', name: '4 Shires Swimming Club' },
    { code: 'ANTWSMSW', name: 'A.N.T. Swimming Club Of Somerset' },
    { code: 'ABVYWWAY', name: 'Aberavon Swimming Club' },
    { code: 'ACDYEWAY', name: 'Aberdare Comets Diving Club' },
    { code: 'NANXSNDX', name: 'Aberdeen ASC' },
    { code: 'NAVXSNDX', name: 'Aberdeen Diving Club' },
    { code: 'NADXSNDX', name: 'Aberdeen Dolphins ASC' },
    { code: 'NABXSNDX', name: 'Aberdeen University Diving Club' },
    { code: 'NAUXSNDX', name: 'Aberdeen University Swimming and WPC' },
    { code: 'ABAYEWAY', name: 'Abergavenny Swimming Club' },
    { code: 'ABTYEWAY', name: 'Abertillery Piranhas Swimming Club' },
    { code: 'ABRYWWAY', name: 'Aberystwyth and District Swimming Club' },
    { code: 'ABISONBS', name: 'Abingdon Vale SC' },
    { code: 'ACELMDXL', name: 'AC East London' },
    { code: 'ASBWSMSW', name: 'Academy Swim Team Burnham' },
    { code: 'ACCNLNCN', name: 'Accrington SC' },
    { code: 'ADWEYRKE', name: 'Adwick (Doncaster) SC' },
    { code: 'AVSYWWAY', name: 'Afan Valley Swimming Club' },
    { code: 'WAMXSCWX', name: 'Airdrie and Monkland ASC' },
    { code: 'AIREYRKE', name: 'Aireborough SC' },
    { code: 'ALBSBSBS', name: 'Albatross DC' },
    { code: 'NAOXSNDX', name: 'Alford Otters ASC' },
    { code: 'ALFADRBA', name: 'Alfreton Swimming Club' },
    { code: 'WAAXSCWX', name: 'Alloa ASC' },
    { code: 'ALNENDRE', name: 'Alnwick Dolphin SC' },
    { code: 'ALSNCHRN', name: 'Alsager SC' },
    { code: 'ALTSHNTS', name: 'Alton & District Swimming Club' },
    { code: 'ALTNCHRN', name: 'Altrincham SC' },
    { code: 'AMESBSBS', name: 'Amersham SC' },
    { code: 'AMMYWWAY', name: 'Amman Valley Swimming Club' },
    { code: 'ANDSHNTS', name: 'Andover Swimming & WP Club' },
    { code: 'WANXSCWX', name: 'Annan ASC' },
    { code: 'APWSHNTS', name: 'Applemore and Waterside SC' },
    { code: 'AFHENDRE', name: 'Aqua Force Swimming Academy Hartlepool' },
    { code: 'ROCNLNCN', name: 'Aquabears Of Rochdale SC' },
    { code: 'AJNENDRE', name: 'AquaJets Newcastle SC' },
    { code: 'AQUTHRTT', name: 'Aqualina (Stevenage) Artistic Swimming Club' },
    { code: 'AASSKNTQ', name: 'Aquaoaks Artistic Swimming Club (Sevenoaks)' },
    { code: 'AQNLMDXL', name: 'Aquavision North London Swim Club' },
    { code: 'ARFYNWAY', name: 'Arfon Swimming Club' },
    { code: 'UACXSCCX', name: 'Argyll & Clyde Swim Team' },
    { code: 'EABXSEDX', name: 'Armadale Barracudas ASC' },
    { code: 'ARMEYRKE', name: 'Armthorpe & District SC' },
    { code: 'ARNANTMA', name: 'Arnold SC' },
    { code: 'ARTSSSXS', name: 'Arun Tridents SC' },
    { code: 'TESQWWKM', name: 'ASA Live Test Club' },
    { code: 'ATEAEASA', name: 'Asa Temporary cat 2 club' },
    { code: 'ASRSBSBS', name: 'Ascot Royals Swim Club' },
    { code: 'ASHADRBA', name: 'Ashbourne & District SC' },
    { code: 'ASHSKNTQ', name: 'Ashford Town SC' },
    { code: 'ASHENDRE', name: 'Ashington SC' },
    { code: 'ASHNLNCN', name: 'Ashton Central SC' },
    { code: 'AULNLNCN', name: 'Ashton-Under-Lyne SC' },
    { code: 'SPAEYRKE', name: 'Askern Spa ASC' },
    { code: 'ASTMWWKM', name: 'Aston (Birmingham) SC' },
    { code: 'ATHNLNCN', name: 'Atherton and Leigh ASC' },
    { code: 'ATLSSSXS', name: 'Atlantis Swimming Club' },
    { code: 'AVOLSRYQ', name: 'Avondale SC' },
    { code: 'AYBSONBS', name: 'Aylesbury & District SC' },
    { code: 'WARXSCWX', name: 'Ayr Diving Club' },
    { code: 'BACWSMSW', name: 'Backwell SC' },
    { code: 'BACADRBA', name: 'Bakewell Swimming Club' },
    { code: 'WBBXSCWX', name: 'Balfron Barracudas' },
    { code: 'BANSONBS', name: 'Banbury SC' },
    { code: 'NBBXSNDX', name: 'Banchory Beavers ASC' },
    { code: 'NBMXSNDX', name: 'Banff and Buchan Masters' },
    { code: 'BBDYNWAY', name: 'Bangor Diving Club' },
    { code: 'BACLESXQ', name: 'Barking & Dagenham Aquatics Club' },
    { code: 'SPALSRYQ', name: 'Barnes SC' },
    { code: 'BANLMDXL', name: 'Barnet Copthall SC' },
    { code: 'BWCLMDXL', name: 'Barnet Water Polo Club' },
    { code: 'RORNLNCN', name: 'Barnoldswick and Earby Amateur Swimming Club' },
    { code: 'BAREYRKE', name: 'Barnsley SC' },
    { code: 'BARWDVNW', name: 'Barnstaple SC' },
    { code: 'BARNCUMN', name: 'Barrow ASC' },
    { code: 'BARYEWAY', name: 'Barry Swimming Club' },
    { code: 'BASTESXQ', name: 'Basildon and Phoenix SC' },
    { code: 'BBFSHNTS', name: 'Basingstoke Bluefins SC' },
    { code: 'BSSANTMA', name: 'Bassetlaw Swim Squad' },
    { code: 'BJSSHNTS', name: 'Bassett J.S.F. Swimming Club' },
    { code: 'BADWSMSW', name: 'Bath Dolphin SC' },
    { code: 'BATIEASA', name: 'Bath Performance Centre' },
    { code: 'EBEXSEDX', name: 'Bathgate ASC' },
    { code: 'BFDSKNTQ', name: 'Beachfield Swimming Squad' },
    { code: 'BCNSSSXS', name: 'Beacon SC' },
    { code: 'BEASHNTS', name: 'Beau Sejour Barracuda SC' },
    { code: 'BEVTBDFT', name: 'Beavers Masters Bedford SC' },
    { code: 'BEBNCHRN', name: 'Bebington SC' },
    { code: 'BEKLKNTQ', name: 'Beckenham SC' },
    { code: 'MODTBDFT', name: 'Bedford Swim Squad' },
    { code: 'BEPTBDFT', name: 'Bedford Water Polo Club' },
    { code: 'WBLXSCWX', name: 'Bellshill Sharks ASC' },
    { code: 'BEMADRBA', name: 'Belper Marlin Swimming Club' },
    { code: 'BASSKNTQ', name: 'Benenden Aquatics' },
    { code: 'BKHTHRTT', name: 'Berkhamsted SC' },
    { code: 'BSBSBSBS', name: 'Berkshire & S Bucks ASA' },
    { code: 'BEGLMDXL', name: 'Bethnal Green SC' },
    { code: 'BEBEYRKE', name: 'Beverley Barracudas SC' },
    { code: 'BXHSSSXS', name: 'Bexhill SC' },
    { code: 'BEMLKNTQ', name: 'Bexley Masters SC' },
    { code: 'BEXLKNTQ', name: 'Bexley SC' },
    { code: 'BXPSKNTQ', name: 'Bexley Water Polo Club (Swanley)' },
    { code: 'BCCSONBS', name: 'Bicester Blue Fins SC' },
    { code: 'BIDMSTFM', name: 'Biddulph SC' },
    { code: 'BWPTBDFT', name: 'Biggleswade SC' },
    { code: 'BILENDRE', name: 'Billingham Forum SC' },
    { code: 'BILMSTFM', name: 'Bilston SC' },
    { code: 'SNPANTMA', name: 'Bingham Penguins SC' },
    { code: 'BIGEYRKE', name: 'Bingley SC' },
    { code: 'BICANTMA', name: 'Bircotes SC' },
    { code: 'BKDNCHRN', name: 'Birkenhead SC' },
    { code: 'BMSMWWKM', name: 'Birmingham Marlins Swimming Club' },
    { code: 'BIRMWWKM', name: 'Birmingham Masters' },
    { code: 'BIRENDRE', name: 'Birtley SC' },
    { code: 'BISTHRTT', name: 'Bishops Stortford SC' },
    { code: 'BSASHNTS', name: 'Bishops Waltham Mitres SwimClub' },
    { code: 'BATLSRYQ', name: 'BJSC Tooting' },
    { code: 'BCPMSTFM', name: 'Black Country n Potteries Masters SC' },
    { code: 'BLASKNTQ', name: 'Black Lion SC' },
    { code: 'BLCNLNCN', name: 'Blackburn Centurion SC' },
    { code: 'BAQNLNCN', name: 'Blackpool Aquatics ASC' },
    { code: 'MBEXSMDX', name: 'Blairgowrie ASC' },
    { code: 'BLFWDRSW', name: 'Blandford SC' },
    { code: 'WBEXSCWX', name: 'Blantyre ASC' },
    { code: 'BLAENDRE', name: 'Blaydon & District SC' },
    { code: 'BAESONBS', name: 'Bletchley and District SC' },
    { code: 'BMASSRYQ', name: 'Blue Marlins Water Polo Club' },
    { code: 'BBSMWWKM', name: 'Blythe Barracudas SC' },
    { code: 'WBSXSCWX', name: 'Bo\'ness ASC' },
    { code: 'BLDMWWKM', name: 'Boldmere Swimming and Water Polo Club' },
    { code: 'BOLENDRE', name: 'Boldon C.A. Swim Club' },
    { code: 'BTMNLNCN', name: 'Bolton Metro Swimming Squad' },
    { code: 'BLNNLNCN', name: 'Bolton SC' },
    { code: 'NBAXSNDX', name: 'Bon Accord Thistle ASC' },
    { code: 'BNLNLNCN', name: 'Bootle & North Liverpool SC' },
    { code: 'BWFLESXQ', name: 'Bor of Waltham Forest (Gators)' },
    { code: 'UBEXSCCX', name: 'Borders Elite Swim Team' },
    { code: 'BORENDRE', name: 'Borocuda Teesside ASC' },
    { code: 'BAMEYRKE', name: 'Borough of Barnsley SC' },
    { code: 'BBSTHRTT', name: 'Borough of Broxbourne Swim Squad' },
    { code: 'HAWLMDXL', name: 'Borough of Harrow S C' },
    { code: 'BOKEYRKE', name: 'Borough of Kirklees SC' },
    { code: 'BOSTESXQ', name: 'Borough of Southend Swimming and Training Club' },
    { code: 'BOSENDRE', name: 'Borough Of Stockton Swim Scheme' },
    { code: 'BOSALNCA', name: 'Boston Amateur SC' },
    { code: 'BOTTCMBT', name: 'Bottisham SC' },
    { code: 'BORSONBS', name: 'Bourne End SC' },
    { code: 'BCSWDRSW', name: 'Bournemouth Collegiate School SC' },
    { code: 'BTHWDRSW', name: 'Bournemouth SC' },
    { code: 'BOXSSRYQ', name: 'Box Hill SC' },
    { code: 'BSCANHPA', name: 'Brackley Swimming Club' },
    { code: 'BRKSBSBS', name: 'Bracknell & Wokingham SC' },
    { code: 'BDSEYRKE', name: 'Bradford Dolphin SC' },
    { code: 'BGSEYRKE', name: 'Bradford Grammar School Swimming Club' },
    { code: 'BRAEYRKE', name: 'Bradford SC' },
    { code: 'BOAWWLTW', name: 'Bradford-On-Avon ASC' },
    { code: 'BTRTESXQ', name: 'Braintree & Bocking SC' },
    { code: 'BRMANTMA', name: 'Bramcote Swimming Club' },
    { code: 'BSTALECA', name: 'Braunstone SC' },
    { code: 'MBBXSMDX', name: 'Brechin Beavers ASC' },
    { code: 'BREYEWAY', name: 'Brecon Swimming Club' },
    { code: 'BOBLMDXL', name: 'Brent Dolphins SC' },
    { code: 'BARTESXQ', name: 'Brentwood Artistic Swimming Club' },
    { code: 'BRETESXQ', name: 'Brentwood SC' },
    { code: 'NBDXSNDX', name: 'Bridge of Don ASC' },
    { code: 'BRINLNCN', name: 'Bridgefield SC' },
    { code: 'BFWNLNCN', name: 'Bridgefield Water Polo Club' },
    { code: 'BRCYEWAY', name: 'Bridgend County Swim Squad' },
    { code: 'BSCYEWAY', name: 'Bridgend Swim Club' },
    { code: 'BRIWSMSW', name: 'Bridgwater Amateur Swimming Club' },
    { code: 'BRDEYRKE', name: 'Bridlington SC' },
    { code: 'BBAWDRSW', name: 'Bridport Barracuda' },
    { code: 'BRGEYRKE', name: 'Brighouse SC' },
    { code: 'BCSSSSXS', name: 'Brighton College Swimming Club' },
    { code: 'BRDSSSXS', name: 'Brighton Dolphin SC' },
    { code: 'BSGWGLUW', name: 'Bristol and South Gloucestershire Swimming Club' },
    { code: 'BRHWGLUW', name: 'Bristol Henleaze SC' },
    { code: 'BRNWGLUW', name: 'Bristol North SC' },
    { code: 'BRASHNTS', name: 'British Army' },
    { code: 'BRXWDVNW', name: 'Brixham SC' },
    { code: 'BSLSKNTQ', name: 'Broadstairs Lifeguard & SC' },
    { code: 'BRDMSTFM', name: 'Broadway (Walsall)' },
    { code: 'BRONLNCN', name: 'Broadway SC (North)' },
    { code: 'NBHXSNDX', name: 'Broch SC' },
    { code: 'BROWGLUW', name: 'Brockworth Swimming Club' },
    { code: 'BRYLKNTQ', name: 'Bromley SC' },
    { code: 'BRBLMDXL', name: 'Brompton SC' },
    { code: 'BROMWRCM', name: 'Bromsgrove SC' },
    { code: 'BROLMDXL', name: 'Broomfield Park SC' },
    { code: 'BRBTHRTT', name: 'Broxbourne SC' },
    { code: 'EBNXSEDX', name: 'Broxburn & District ASC' },
    { code: 'NBKXSNDX', name: 'Buckie ASC' },
    { code: 'BUCSONBS', name: 'Buckingham Swans' },
    { code: 'BUCYNWAY', name: 'Buckley Swimming Club' },
    { code: 'NBNXSNDX', name: 'Bucksburn ASC' },
    { code: 'BUDWCWLW', name: 'Bude Sharks' },
    { code: 'BOSWSMSW', name: 'Burnham-on-Sea SC' },
    { code: 'BUBNLNCN', name: 'Burnley BOBCATS ADM SC' },
    { code: 'EBDXSEDX', name: 'Burntisland ASC' },
    { code: 'BRWMSTFM', name: 'Burntwood Swimming Club' },
    { code: 'BDCNLNCN', name: 'Burscough Diving Club' },
    { code: 'BURMSTFM', name: 'Burton Amateur SC' },
    { code: 'BRYNLNCN', name: 'Bury and Elton SC' },
    { code: 'BWPNLNCN', name: 'Bury Water Polo Club' },
    { code: 'BUSTHRTT', name: 'Bushey Amateur Swimming Club' },
    { code: 'BUXADRBA', name: 'Buxton & District SC' },
    { code: 'CAPYEWAY', name: 'Caerphilly County Swim Squad' },
    { code: 'CALYEWAY', name: 'Caldicot Swimming Club' },
    { code: 'UCDXSCCX', name: 'Caledonia' },
    { code: 'USCXSCCX', name: 'Caledonia Synchro' },
    { code: 'CMILMDXL', name: 'Cally Masters Islington' },
    { code: 'CAFWWLTW', name: 'Calne Alpha Four ASC' },
    { code: 'CALANTMA', name: 'Calverton and Bingham SC' },
    { code: 'CAAYNWAY', name: 'Cambrian Aquatics Academy' },
    { code: 'CDTTCMBT', name: 'Cambridge Dive Team' },
    { code: 'CAUTCMBT', name: 'Cambridge University Swimming & Water Polo Club' },
    { code: 'CSCLMDXL', name: 'Camden Swiss Cottage SC' },
    { code: 'CAMWCWLW', name: 'Camelford Stingers' },
    { code: 'CHEMWWKM', name: 'Camp Hill Edwardians SC' },
    { code: 'CAHMWWKM', name: 'Camp Hill SC' },
    { code: 'PHYMSTFM', name: 'Cannock Phoenix Swimming Club' },
    { code: 'CNVTESXQ', name: 'Canvey Island SC' },
    { code: 'CRNWCWLW', name: 'Caradon SC' },
    { code: 'ECNXSEDX', name: 'Cardenden ASC' },
    { code: 'CDMYEWAY', name: 'Cardiff Masters Swimming Club' },
    { code: 'CAQNCUMN', name: 'Carlisle Aquatics' },
    { code: 'CARANTMA', name: 'Carlton Forum SC' },
    { code: 'CAMYWWAY', name: 'Carmarthen & District Swimming Club' },
    { code: 'CWPYWWAY', name: 'Carmarthen Water Polo Club' },
    { code: 'CMMYWWAY', name: 'Carmarthenshire Masters Swimming Club' },
    { code: 'CARWCWLW', name: 'Carn Brea and Helston SC' },
    { code: 'ECEXSEDX', name: 'Carnegie ASC' },
    { code: 'CDONLNCN', name: 'Carnforth & Dist Otters' },
    { code: 'MCCXSMDX', name: 'Carnoustie Claymores' },
    { code: 'CMAWCWLW', name: 'Carrick Masters' },
    { code: 'CWPEYRKE', name: 'Castleford WPC' },
    { code: 'CAWSSRYQ', name: 'Cawpra SC' },
    { code: 'CEDYWWAY', name: 'Celtic Dolphins Swimming Club' },
    { code: 'CHANLNCN', name: 'Chadderton SC' },
    { code: 'CHASBSBS', name: 'Chalfont Otters SC' },
    { code: 'CHPEYRKE', name: 'Chapeltown SC' },
    { code: 'CHSMSTFM', name: 'Chase SC' },
    { code: 'CHKTCMBT', name: 'Chatteris Kingfishers SC' },
    { code: 'CSDMSTFM', name: 'Cheadle (Staffs) & District' },
    { code: 'CHLLSRYQ', name: 'Cheam Marcuda SC' },
    { code: 'CHDWSMSW', name: 'Cheddar Kingfishers SC' },
    { code: 'CHETESXQ', name: 'Chelmsford City SC' },
    { code: 'CWSLMDXL', name: 'Chelsea & Westminster SC' },
    { code: 'CASWGLUW', name: 'Cheltenham Artistic Swimming Club' },
    { code: 'CPAWGLUW', name: 'Cheltenham Phoenix Aquatics Club' },
    { code: 'CHEWGLUW', name: 'Cheltenham S & W P Club' },
    { code: 'CHEYEWAY', name: 'Chepstow & District Swimming Club' },
    { code: 'CHMSBSBS', name: 'Chesham SC' },
    { code: 'CHRNCHRN', name: 'Cheshire County WPSA' },
    { code: 'CHSTHRTT', name: 'Cheshunt Swimming Club' },
    { code: 'CLSENDRE', name: 'Chester-Le-Street SC' },
    { code: 'CFDADRBA', name: 'Chesterfield Swimming Club' },
    { code: 'CHISSSXS', name: 'Chichester (Cormorant) SC' },
    { code: 'CHIWWLTW', name: 'Chippenham ASC' },
    { code: 'CHIYNWAY', name: 'Chirk Dragons Swimming Club' },
    { code: 'CMSLKNTQ', name: 'Chislehurst Millennium Swim Squad' },
    { code: 'CHMLMDXL', name: 'Chiswick Masters' },
    { code: 'CMANLNCN', name: 'Chorley Marlins SC' },
    { code: 'CIRWGLUW', name: 'Cirencester SC' },
    { code: 'CWPLMDXL', name: 'Citizens Water Polo Club' },
    { code: 'BHMMWWKM', name: 'City of Birmingham SC' },
    { code: 'CBEEYRKE', name: 'City of Bradford Esprit Diving' },
    { code: 'COBEYRKE', name: 'City of Bradford SC' },
    { code: 'BRISSSXS', name: 'City of Brighton and Hove' },
    { code: 'COBWGLUW', name: 'City of Bristol SC' },
    { code: 'CAMTCMBT', name: 'City of Cambridge SC' },
    { code: 'CANSKNTQ', name: 'City of Canterbury SC' },
    { code: 'COCYEWAY', name: 'City of Cardiff' },
    { code: 'COCNCHRN', name: 'City of Chester Swimming Club' },
    { code: 'COVMWWKM', name: 'City of Coventry SC' },
    { code: 'DMREYRKE', name: 'City of Doncaster Masters Swim Squad' },
    { code: 'ELYTCMBT', name: 'City Of Ely Amateur Swimming Club' },
    { code: 'WCGXSCWX', name: 'City Of Glasgow Swim Team' },
    { code: 'HERMWRCM', name: 'City of Hereford SC' },
    { code: 'LDCEYRKE', name: 'City of Leeds Diving Club' },
    { code: 'LDSEYRKE', name: 'City of Leeds SC' },
    { code: 'LSYEYRKE', name: 'City Of Leeds Synchronised SC' },
    { code: 'CLWEYRKE', name: 'City of Leeds Water Polo Club' },
    { code: 'COLALECA', name: 'City of Leicester SC' },
    { code: 'CLPALNCA', name: 'City of Linc Pentaqua SC' },
    { code: 'LPLNLNCN', name: 'City of Liverpool SC' },
    { code: 'MANNLNCN', name: 'City of Manchester Aquatics' },
    { code: 'CMWNLNCN', name: 'City of Manchester WPC' },
    { code: 'CMKSONBS', name: 'City Of Milton Keynes' },
    { code: 'NWMYEWAY', name: 'City Of Newport Swimming & Water Polo Club' },
    { code: 'NORTNRFT', name: 'City of Norwich SC' },
    { code: 'OXFSONBS', name: 'City Of Oxford SC' },
    { code: 'COWSONBS', name: 'City Of Oxford Water Polo Club' },
    { code: 'PETTCMBT', name: 'City Of Peterborough SC' },
    { code: 'CPANLNCN', name: 'City of Preston Aquatics SC' },
    { code: 'SAFNLNCN', name: 'City of Salford SC' },
    { code: 'CSANLNCN', name: 'City of Salford Synchronised Swimming Club' },
    { code: 'SHDEYRKE', name: 'City of Sheffield Diving Club' },
    { code: 'COSEYRKE', name: 'City of Sheffield Swim Squad Ltd' },
    { code: 'SWPEYRKE', name: 'City of Sheffield WPC' },
    { code: 'COSSHNTS', name: 'City of Southampton SC' },
    { code: 'SOSTESXQ', name: 'City of Southend on Sea SC' },
    { code: 'SASTHRTT', name: 'City of St Albans SC' },
    { code: 'CITMSTFM', name: 'City of Stoke SC (Cosacss)' },
    { code: 'SUNENDRE', name: 'City of Sunderland ASC' },
    { code: 'SWAYWWAY', name: 'City of Swansea Aquatics Club' },
    { code: 'WAKEYRKE', name: 'City of Wakefield SC' },
    { code: 'CLATESXQ', name: 'Clacton Swimming Club' },
    { code: 'CLDEYRKE', name: 'Cleethorpes & Dist SC' },
    { code: 'CLEWSMSW', name: 'Clevedon SC' },
    { code: 'CLINLNCN', name: 'Clitheroe District SC' },
    { code: 'BANYNWAY', name: 'Clwb Nofio Bangor Swim Club' },
    { code: 'CANYNWAY', name: 'Clwb Nofio Caernarfon' },
    { code: 'PBPYNWAY', name: 'Clwb Nofio P.B.P.' },
    { code: 'IOAYNWAY', name: 'Clwb Nofio Ynys Mon | Isle of Anglesey Swimming Club' },
    { code: 'WCKXSCWX', name: 'Clydebank ASC' },
    { code: 'COAALECA', name: 'Coalville SC' },
    { code: 'COKNCUMN', name: 'Cockermouth SC' },
    { code: 'COPTESXQ', name: 'Colchester Phoenix ASC' },
    { code: 'COLTESXQ', name: 'Colchester Swimming & Water Polo Club' },
    { code: 'COLNLNCN', name: 'Colne SC' },
    { code: 'CONENDRE', name: 'Consett SC' },
    { code: 'COPNCUMN', name: 'Copeland ASC' },
    { code: 'CORANHPA', name: 'Corby ASC' },
    { code: 'CSDANHPA', name: 'Corby Steel Diving' },
    { code: 'CWLWCWLW', name: 'Cornwall ASA' },
    { code: 'CORWWLTW', name: 'Corsham A.S.C.' },
    { code: 'CSHYNWAY', name: 'Corwen Sharks Swimming Club' },
    { code: 'CRASSRYQ', name: 'Cranleigh SC' },
    { code: 'CRWSSSXS', name: 'Crawley SC' },
    { code: 'CREWDVNW', name: 'Crediton & District SC' },
    { code: 'CRENCHRN', name: 'Crewe Flyers SC' },
    { code: 'CRONLNCN', name: 'Crosby SC' },
    { code: 'CROLSRYQ', name: 'Croydon Amphibians SC' },
    { code: 'CPMLSRYQ', name: 'Crystal Palace Masters Swimming Club' },
    { code: 'NCOXSNDX', name: 'Cults Otters ASC' },
    { code: 'WCDXSCWX', name: 'Cumbernauld ASC' },
    { code: 'CUMNCUMN', name: 'Cumbria ASA' },
    { code: 'ECRXSEDX', name: 'Cupar and District Swimming Club' },
    { code: 'CWMYEWAY', name: 'Cwmbran Swimming Club' },
    { code: 'DASTHRTT', name: 'Dacorum Artistic SC' },
    { code: 'SADTHRTT', name: 'Dacorum Diving Club' },
    { code: 'DDMENDRE', name: 'Darlington Dolphin Masters SC' },
    { code: 'DARENDRE', name: 'Darlington SC' },
    { code: 'DARSKNTQ', name: 'Dartford District SC' },
    { code: 'DSCWDVNW', name: 'Dartmouth Swimming Club' },
    { code: 'DMANLNCN', name: 'Darwen Masters Swimming Club' },
    { code: 'DAVANHPA', name: 'Daventry Dolphins SC' },
    { code: 'DAWWDVNW', name: 'Dawlish SC' },
    { code: 'DTRSKNTQ', name: 'Deal Tri Masters Swim Club' },
    { code: 'DCMEYRKE', name: 'Dearne Valley SC' },
    { code: 'DEBTSFKT', name: 'Deben SC' },
    { code: 'DEEALNCA', name: 'Deepings SC' },
    { code: 'NDDXSNDX', name: 'Delting Dolphins ASC' },
    { code: 'DENYNWAY', name: 'Denbigh Dragons Swim Club' },
    { code: 'DSSNLNCN', name: 'Denton Artistic Swimming Club' },
    { code: 'DEXADRBA', name: 'Derby Excel Swimming Club' },
    { code: 'DEPADRBA', name: 'Derby Phoenix SC' },
    { code: 'DRBADRBA', name: 'Derbyshire ASA' },
    { code: 'DADTNRFT', name: 'Dereham & District ASC' },
    { code: 'DEVEYRKE', name: 'Derwent Valley SC' },
    { code: 'DAGENDRE', name: 'Derwentside & Gateshead Swim Team' },
    { code: 'NDNXSNDX', name: 'Deveron ASC' },
    { code: 'DEVWWLTW', name: 'Devizes ASC' },
    { code: 'DVNWDVNW', name: 'Devon County ASA' },
    { code: 'DERWDVNW', name: 'Devonport RSA' },
    { code: 'DBYEYRKE', name: 'Dewsbury SC' },
    { code: 'DABSONBS', name: 'Didcot & Barramundi SC' },
    { code: 'NDIXSNDX', name: 'Dingwall ASC' },
    { code: 'DINWDVNW', name: 'Dinnaton SC' },
    { code: 'DOTTNRFT', name: 'Diss Otters SC' },
    { code: 'DLALESXQ', name: 'Dive London Aquatics Club' },
    { code: 'DODEYRKE', name: 'Doncaster Dartes SC' },
    { code: 'DORSSRYQ', name: 'Dorking Swimming Club' },
    { code: 'DRSWDRSW', name: 'Dorset County ASA' },
    { code: 'DOUNLNCN', name: 'Douglas SC' },
    { code: 'DOVMSTFM', name: 'Dove Valley SC' },
    { code: 'DLCSKNTQ', name: 'Dover Lifeguard Swimming Club' },
    { code: 'DSSTESXQ', name: 'Down Syndrome Swimming Great Britain' },
    { code: 'DFDEYRKE', name: 'Driffield SC' },
    { code: 'DTDMWRCM', name: 'Droitwich Dolphins SC' },
    { code: 'DRDADRBA', name: 'Dronfield Dolphins SC' },
    { code: 'DTSWDVNW', name: 'DTs' },
    { code: 'DUKNCHRN', name: 'Dukinfield Marlins ASC' },
    { code: 'DUDLSRYQ', name: 'Dulwich Dolphins' },
    { code: 'WDSXSCWX', name: 'Dumfries ASC' },
    { code: 'MDCXSMDX', name: 'Dundee City Aquatics SC' },
    { code: 'MDDXSMDX', name: 'Dundee Diving' },
    { code: 'MDUXSMDX', name: 'Dundee University Swimming & WPC' },
    { code: 'EDDXSEDX', name: 'Dunedin Swim Team' },
    { code: 'EDEXSEDX', name: 'Dunfermline ASC' },
    { code: 'EDUXSEDX', name: 'Dunfermline Water Polo Club' },
    { code: 'DUATESXQ', name: 'Dunmow Atlantis SC' },
    { code: 'WDNXSCWX', name: 'Dunoon ASC' },
    { code: 'EDSXSEDX', name: 'Duns ASC' },
    { code: 'DUBTBDFT', name: 'Dunstable SC' },
    { code: 'DUWTBDFT', name: 'Dunstable Water Polo Club' },
    { code: 'DURENDRE', name: 'Durham City ASC' },
    { code: 'DURWWLTW', name: 'Durrington Otters' },
    { code: 'DDOWGLUW', name: 'Dursley Dolphins' },
    { code: 'NDAXSNDX', name: 'Dyce (Aberdeen) ASC' },
    { code: 'EALLMDXL', name: 'Ealing SC' },
    { code: 'EANTNRFT', name: 'East Anglian Swallow Tails' },
    { code: 'EAGSSSXS', name: 'East Grinstead Swimming Club' },
    { code: 'EIESKNTQ', name: 'East Invicta eXcel' },
    { code: 'WEKXSCWX', name: 'East Kilbride ASC' },
    { code: 'ELEEYRKE', name: 'East Leeds SC' },
    { code: 'UELXSCCX', name: 'East Lothian Swim Team' },
    { code: 'MLDAEASA', name: 'East Midland Region' },
    { code: 'EASTEASA', name: 'East Region' },
    { code: 'NESXSNDX', name: 'East Sutherland Swimming Club' },
    { code: 'EASSSSXS', name: 'Eastbourne SC' },
    { code: 'EOTLESXQ', name: 'Eastern Otters Water Polo Club' },
    { code: 'EATSHNTS', name: 'Eastleigh SC' },
    { code: 'EASLMDXL', name: 'Eaton Square SC' },
    { code: 'ECKADRBA', name: 'Eckington SC' },
    { code: 'EDPSKNTQ', name: 'Edenbridge Piranhas SC' },
    { code: 'EEDXSEDX', name: 'Edinburgh Diving Club' },
    { code: 'EESXSEDX', name: 'Edinburgh Synchro ASC' },
    { code: 'EEUXSEDX', name: 'Edinburgh University' },
    { code: 'EDLEYRKE', name: 'Edlington SC' },
    { code: 'EEWSBSBS', name: 'Electric Eels of Windsor SC' },
    { code: 'NENXSNDX', name: 'Elgin SC' },
    { code: 'ECSMSHPM', name: 'Ellesmere College Swimming Academy' },
    { code: 'ELLNCHRN', name: 'Ellesmere Port SC' },
    { code: 'ELMSSRYQ', name: 'Elmbridge Phoenix SC' },
    { code: 'EMSLKNTQ', name: 'Eltham Stingrays' },
    { code: 'WEAXSCWX', name: 'Enable Arion SC' },
    { code: 'ENSLMDXL', name: 'Enfield Swim Squad' },
    { code: 'ERMEYRKE', name: 'English Roses Masters WPC' },
    { code: 'EPPTESXQ', name: 'Epping Forest District SC' },
    { code: 'EPSSSRYQ', name: 'Epsom District SC' },
    { code: 'ERILKNTQ', name: 'Erith & District SC' },
    { code: 'ESTENDRE', name: 'Eston SC' },
    { code: 'ETEADRBA', name: 'Etwall Eagles SC' },
    { code: 'EVENLNCN', name: 'Everton Swimming Assoc' },
    { code: 'EVEMWRCM', name: 'Evesham SC' },
    { code: 'EMAWDVNW', name: 'Exe Masters Swimming Club' },
    { code: 'EXCWDVNW', name: 'Exeter City Swimming Club' },
    { code: 'EUAWDVNW', name: 'Exeter University Alumni Swimming Club' },
    { code: 'ECWWDVNW', name: 'Exeter University Water Polo Club' },
    { code: 'EXEWDVNW', name: 'Exeter Waterpolo & Swimming Club' },
    { code: 'EXMWDVNW', name: 'Exmouth Swimming Club' },
    { code: 'EEHXSEDX', name: 'Eyemouth & District ASC' },
    { code: 'UFTXSCCX', name: 'Falkirk Inter-Region Swim Team' },
    { code: 'WFOXSCWX', name: 'Falkirk Otters ASC' },
    { code: 'FANSHNTS', name: 'Fareham Nomads SC' },
    { code: 'FARSSRYQ', name: 'Farnham SC' },
    { code: 'EFPXSEDX', name: 'Fauldhouse Penguins SC' },
    { code: 'FAVSKNTQ', name: 'Faversham SC' },
    { code: 'FLXTSFKT', name: 'Felixstowe SC' },
    { code: 'FELLMDXL', name: 'Feltham SC' },
    { code: 'EFAXSEDX', name: 'Ferry Amateur Swim Team' },
    { code: 'UFNXSCCX', name: 'Fife North East Swim Team' },
    { code: 'EFEXSEDX', name: 'Fife Synchronised Swimming Club' },
    { code: 'EFSXSEDX', name: 'Fins CSC' },
    { code: 'FISYWWAY', name: 'Fishguard Flyers Swimming Club' },
    { code: 'FLENLNCN', name: 'Fleetwood Mako\'s' },
    { code: 'FLIYNWAY', name: 'Flint Swimming Club' },
    { code: 'MBDTBDFT', name: 'Flitwick Dolphins SC' },
    { code: 'FSTNLNCN', name: 'Flixton SC' },
    { code: 'FOLSKNTQ', name: 'Folkestone SC' },
    { code: 'FODWGLUW', name: 'Forest of Dean SC' },
    { code: 'MFRXSMDX', name: 'Forfar ASC' },
    { code: 'FSCNLNCN', name: 'Formby Swimming Club' },
    { code: 'NFBXSNDX', name: 'Forres Blu Fins ASC' },
    { code: 'WFTXSCWX', name: 'Forth Valley Tridents' },
    { code: 'WFVXSCWX', name: 'Forth Valley WPC' },
    { code: 'FORLMDXL', name: 'Forward Hillingdon Squad' },
    { code: 'NFSXSNDX', name: 'Free Style SC' },
    { code: 'FMSLMDXL', name: 'Frognal Masters Swimming Club' },
    { code: 'FROWSMSW', name: 'Frome SC' },
    { code: 'GRDALNCA', name: 'Gainsborough Dolphins SC' },
    { code: 'EGAXSEDX', name: 'Galashiels ASC' },
    { code: 'NGHXSNDX', name: 'Garioch ASC' },
    { code: 'GTGNLNCN', name: 'Garstang SC' },
    { code: 'GARNLNCN', name: 'Garston SC' },
    { code: 'GHSENDRE', name: 'Gateshead Artistic Swimming Club' },
    { code: 'GGEYNWAY', name: 'Gele Gators Swimming Club' },
    { code: 'WNSXSCWX', name: 'Glasgow Nomads SC' },
    { code: 'WGUXSCWX', name: 'Glasgow University Swim Team' },
    { code: 'WWMXSCWX', name: 'Glasgow Western Masters ASC' },
    { code: 'EGSXSEDX', name: 'Glenrothes ASC' },
    { code: 'GLOADRBA', name: 'Glossop ASC' },
    { code: 'GLUWGLUW', name: 'Gloucester ASA' },
    { code: 'GLOWGLUW', name: 'Gloucester City SC' },
    { code: 'GLMWGLUW', name: 'Gloucester Masters SC' },
    { code: 'GODSSRYQ', name: 'Godalming ASC' },
    { code: 'GOSSHNTS', name: 'Gosport Dolphins SC' },
    { code: 'WGHXSCWX', name: 'Grangemouth ASC' },
    { code: 'GRNALNCA', name: 'Grantham SC' },
    { code: 'KWPALNCA', name: 'Grantham Water Polo Club' },
    { code: 'NGRXSNDX', name: 'Grantown-on-Spey SC' },
    { code: 'GRASKNTQ', name: 'Gravesend & Northfleet SC' },
    { code: 'BODSSSXS', name: 'Great Britain Deaf Swimming Club' },
    { code: 'GBPENDRE', name: 'Great Britain Police' },
    { code: 'GHONLNCN', name: 'Great Harwood Otters SC' },
    { code: 'GYATNRFT', name: 'Great Yarmouth SC' },
    { code: 'GASANTMA', name: 'Green Arrows SSC' },
    { code: 'GWRLKNTQ', name: 'Greenwich Royals SC' },
    { code: 'EGEXSEDX', name: 'Grove ASC' },
    { code: 'GUESHNTS', name: 'Guernsey Swimming Club' },
    { code: 'GWPSHNTS', name: 'Guernsey Water Polo LBG' },
    { code: 'GUISSRYQ', name: 'Guildford City Swimming Club' },
    { code: 'CRNSSRYQ', name: 'Guildford Water Polo Club' },
    { code: 'GUIENDRE', name: 'Guisborough SC' },
    { code: 'HAGLMDXL', name: 'Hackney Anaconda' },
    { code: 'EHNXSEDX', name: 'Haddington & District ASC' },
    { code: 'HADTSFKT', name: 'Hadleigh and Sudbury Swimming Club' },
    { code: 'EHAXSEDX', name: 'Hailes ASC' },
    { code: 'HAISSSXS', name: 'Hailsham SC' },
    { code: 'HALMWRCM', name: 'Halesowen SC' },
    { code: 'HSWTSFKT', name: 'Halesworth & District SC' },
    { code: 'HALEYRKE', name: 'Halifax SC' },
    { code: 'HASTESXQ', name: 'Halstead Swimming Club' },
    { code: 'WIDNCHRN', name: 'Halton SC' },
    { code: 'HAQSHNTS', name: 'Hamble Aquatics Swim Team' },
    { code: 'HASEYRKE', name: 'Hambleton Swim Squad' },
    { code: 'WHBXSCWX', name: 'Hamilton Baths ASC' },
    { code: 'WHNXSCWX', name: 'Hamilton Dolphins' },
    { code: 'WHWXSCWX', name: 'Hamilton Water Polo Club' },
    { code: 'HNTSHNTS', name: 'Hampshire County ASA' },
    { code: 'HGSMWWKM', name: 'Handsworth Grammar Sch Old Boys' },
    { code: 'HABLMDXL', name: 'Haringey Aquatics' },
    { code: 'HALTESXQ', name: 'Harlow Penguin SC' },
    { code: 'HRPTHRTT', name: 'Harpenden SC' },
    { code: 'HARNLNCN', name: 'Harpurhey SC' },
    { code: 'HAREYRKE', name: 'Harrogate District SC' },
    { code: 'HDCEYRKE', name: 'Harrogate Diving Club' },
    { code: 'HRWLMDXL', name: 'Harrow Scout & Guide SC' },
    { code: 'HARSHNTS', name: 'Hart Swimming Club' },
    { code: 'HATENDRE', name: 'Hartlepool SC' },
    { code: 'HDPTESXQ', name: 'Harwich Dovercourt/Parkeston SC' },
    { code: 'HSMSSRYQ', name: 'Haslemere Swimming Club' },
    { code: 'HSGSSSXS', name: 'Hastings Seagull SC' },
    { code: 'HDCTHRTT', name: 'Hatfield Diving Club' },
    { code: 'HATTHRTT', name: 'Hatfield SC' },
    { code: 'HVWSHNTS', name: 'Havant & Waterlooville SC' },
    { code: 'HAVYWWAY', name: 'Haverfordwest Swimming Club' },
    { code: 'ECDLESXQ', name: 'Havering Cormorants Diving Club' },
    { code: 'EHTXSEDX', name: 'Hawick & Teviotdale ASC' },
    { code: 'HAZNCHRN', name: 'Hazel Gr/Bramhall (Saracens) SC' },
    { code: 'HOVYEWAY', name: 'Heads of the Valleys Swimming Club' },
    { code: 'EHMXSEDX', name: 'Heart Of Midlothian ASC' },
    { code: 'HTHMSTFM', name: 'Heath Town SC' },
    { code: 'HEBENDRE', name: 'Hebburn Metro SC' },
    { code: 'HEESHNTS', name: 'Hedge End Swimming Club' },
    { code: 'WHHXSCWX', name: 'Helensburgh ASC' },
    { code: 'HEMTHRTT', name: 'Hemel Hempstead SC' },
    { code: 'HLSSONBS', name: 'Henley Leisure Swimming Club' },
    { code: 'HENSONBS', name: 'Henley SC' },
    { code: 'HNBSKNTQ', name: 'Herne Bay L&SC' },
    { code: 'HCEWSMSW', name: 'Heron Swim Team Somerset' },
    { code: 'HERTHRTT', name: 'Hertford SC' },
    { code: 'HACTHRTT', name: 'Hertfordshire Aquatics Club' },
    { code: 'HETENDRE', name: 'Hetton SC' },
    { code: 'HDCSKNTQ', name: 'Highgate DC (Kent)' },
    { code: 'NHDXSNDX', name: 'Highland Disability Swim Team' },
    { code: 'UHIXSCCX', name: 'Highland Swim Team' },
    { code: 'TDCWWLTW', name: 'Highworth Phoenix Diving Club' },
    { code: 'HISLMDXL', name: 'Hillingdon Swimming Club' },
    { code: 'HINALECA', name: 'Hinckley SC' },
    { code: 'HINNLNCN', name: 'Hindley SC' },
    { code: 'HITTHRTT', name: 'Hitchin SC' },
    { code: 'HODTHRTT', name: 'Hoddesdon SC' },
    { code: 'HOLYNWAY', name: 'Holywell Swimming Club' },
    { code: 'HONWDVNW', name: 'Honiton SC' },
    { code: 'HORALNCA', name: 'Horncastle Otters SC' },
    { code: 'HORLESXQ', name: 'Hornchurch SC' },
    { code: 'HORWSMSW', name: 'Horton & Broadway Swimming Club' },
    { code: 'HLCNLNCN', name: 'Horwich Leisure Centre SC' },
    { code: 'HOJLMDXL', name: 'Hounslow Jets' },
    { code: 'HBANLNCN', name: 'Howe Bridge Aces SC' },
    { code: 'HOYNCHRN', name: 'Hoylake SC' },
    { code: 'HUKANTMA', name: 'Hucknall SC' },
    { code: 'RRHANTMA', name: 'Hucknall WPC' },
    { code: 'HUOEYRKE', name: 'Huddersfield Otters SC' },
    { code: 'HWPEYRKE', name: 'Hull Water Polo Club' },
    { code: 'HUNTCMBT', name: 'Huntingdon Piranhas SC' },
    { code: 'NHYXSNDX', name: 'Huntly ASC' },
    { code: 'HYDNCHRN', name: 'Hyde Seal Swimming Club' },
    { code: 'HYTSKNTQ', name: 'Hythe Aqua' },
    { code: 'HYASKNTQ', name: 'Hythe Artistic Swimming Club' },
    { code: 'ILFWDVNW', name: 'Ilfracombe SC' },
    { code: 'ILKADRBA', name: 'Ilkeston SC' },
    { code: 'ILKEYRKE', name: 'Ilkley SC' },
    { code: 'ILMWSMSW', name: 'Ilminster Swimming Club' },
    { code: 'IMPTCMBT', name: 'Impington SC' },
    { code: 'EISXSEDX', name: 'Incas' },
    { code: 'ISMSONBS', name: 'InSync - Milton Keynes Synchronised Swimming Club' },
    { code: 'WIEXSCWX', name: 'Inverclyde ASC' },
    { code: 'WIMXSCWX', name: 'Inverclyde Masters ASC' },
    { code: 'EIHXSEDX', name: 'Inverleith' },
    { code: 'NISXSNDX', name: 'Inverness ASC' },
    { code: 'INVSKNTQ', name: 'Invicta WPC' },
    { code: 'NIAXSNDX', name: 'ISA Aberdeen' },
    { code: 'WIJXSCWX', name: 'Islay & Jura Dolphins ASC' },
    { code: 'IOMNLNCN', name: 'Isle of Man Swimming Club' },
    { code: 'IOMSHNTS', name: 'Isle Of Wight Marlins Swim Club' },
    { code: 'JLDSHNTS', name: 'Jersey Long Distance' },
    { code: 'JERSHNTS', name: 'Jersey SC' },
    { code: 'JWPSHNTS', name: 'Jersey Water Polo Association' },
    { code: 'EKOXSEDX', name: 'Kelso ASC' },
    { code: 'KENNCUMN', name: 'Kendal SC' },
    { code: 'KEMMWWKM', name: 'Kenilworth Masters SC' },
    { code: 'KNTQKNTQ', name: 'Kent County ASA' },
    { code: 'KWSSKNTQ', name: 'Kent Weald Swim Squad' },
    { code: 'SAYWCWLW', name: 'Kernow Artistic Swimming Club' },
    { code: 'KETANHPA', name: 'Kettering Amateur Swimming Club' },
    { code: 'KEYWSMSW', name: 'Keynsham SC' },
    { code: 'KAGSONBS', name: 'Kidlington & Gosford SC' },
    { code: 'KILLESXQ', name: 'Killerwhales SC (Havering)' },
    { code: 'WKKXSCWX', name: 'Kilmarnock ASC' },
    { code: 'KIMANTMA', name: 'Kimberley SC' },
    { code: 'KINEYRKE', name: 'Kingfishers Scarborough SC' },
    { code: 'KCSLSRYQ', name: 'Kings Cormorants SC' },
    { code: 'KINTHRTT', name: 'Kings Langley SC' },
    { code: 'KKFWDVNW', name: 'Kingsbridge Kingfishers SC' },
    { code: 'KAQMWWKM', name: 'Kingsbury Aquarius SC' },
    { code: 'KLDSSRYQ', name: 'Kingston Artistic Swimming Club' },
    { code: 'WKNXSCWX', name: 'Kingston ASC' },
    { code: 'KIRLSRYQ', name: 'Kingston Royals SC' },
    { code: 'KUHEYRKE', name: 'Kingston Upon Hull SC' },
    { code: 'MKOXSMDX', name: 'Kinross Otters ASC' },
    { code: 'WKEXSCWX', name: 'Kintyre ASC' },
    { code: 'KIPEYRKE', name: 'Kippax SC' },
    { code: 'EKYXSEDX', name: 'Kirkcaldy ASC' },
    { code: 'WKTXSCWX', name: 'Kirkcudbright SC' },
    { code: 'KIRNLNCN', name: 'Kirkham & Wesham SC' },
    { code: 'WKHXSCWX', name: 'Kirkintilloch & Kilsyth ASC' },
    { code: 'KNTEYRKE', name: 'Knottingley ASC' },
    { code: 'KNUNCHRN', name: 'Knutsford Amateur Swimming Club' },
    { code: 'WLKXSCWX', name: 'Lanark' },
    { code: 'LNCNLNCN', name: 'Lancashire County WPSA' },
    { code: 'LANNLNCN', name: 'Lancaster City SC' },
    { code: 'LCSSSSXS', name: 'Lancing College Swimming Club' },
    { code: 'LARSKNTQ', name: 'Larkfield SC' },
    { code: 'WLAXSCWX', name: 'Larkhall Avondale ASC' },
    { code: 'WLWXSCWX', name: 'Larkhall Water Polo Club' },
    { code: 'LSCWCWLW', name: 'Launceston SC' },
    { code: 'SPAMWWKM', name: 'Leamington Spa SC' },
    { code: 'LEALSRYQ', name: 'Leander SC' },
    { code: 'LETSSRYQ', name: 'Leatherhead SC' },
    { code: 'LADMWRCM', name: 'Ledbury & Malvern SC' },
    { code: 'LUAEYRKE', name: 'Leeds University Aquatics SC' },
    { code: 'LEEMSTFM', name: 'Leek ASC' },
    { code: 'LEMALECA', name: 'Leicester Masters' },
    { code: 'PENALECA', name: 'Leicester Penguins SC' },
    { code: 'LSHALECA', name: 'Leicester Sharks Swimming Club' },
    { code: 'LECALECA', name: 'Leicestershire ASA' },
    { code: 'LBOTBDFT', name: 'Leighton Buzzard Otters Swimming Club for the Disabled' },
    { code: 'LBZTBDFT', name: 'Leighton Buzzard SC' },
    { code: 'LLDTBDFT', name: 'Leighton Linslade Swimming Club' },
    { code: 'LDSTSFKT', name: 'Leiston & District Swimming Club' },
    { code: 'ELHXSEDX', name: 'Leith ASC' },
    { code: 'NLKXSNDX', name: 'Lerwick ASC' },
    { code: 'LCHTHRTT', name: 'Letchworth ASC' },
    { code: 'LEWSSSXS', name: 'Lewes SC' },
    { code: 'LWPLKNTQ', name: 'Lewisham Water Polo Club' },
    { code: 'LEYNLNCN', name: 'Leyland Barracudas Swimming Club' },
    { code: 'KEYLESXQ', name: 'Leyton SC' },
    { code: 'LICMSTFM', name: 'Lichfield SC' },
    { code: 'LTSALNCA', name: 'Lincoln Trident Swimming Academy' },
    { code: 'VULALNCA', name: 'Lincoln Vulcans SC' },
    { code: 'LNCALNCA', name: 'Lincolnshire ASA' },
    { code: 'LCRTBDFT', name: 'Linslade Crusaders Swimming Club' },
    { code: 'LIVNLNCN', name: 'Liverpool Penguins SC' },
    { code: 'ELDXSEDX', name: 'Livingston & District Dolphins' },
    { code: 'ELNXSEDX', name: 'Livingston Swim Club' },
    { code: 'LNDYNWAY', name: 'Llandudno Swimming Club' },
    { code: 'LLLYWWAY', name: 'Llanelli Swimming Club' },
    { code: 'NLRXSNDX', name: 'Lochaber Leisure Centre Swim Team' },
    { code: 'LSSSHNTS', name: 'Locks Heath Swim Squad' },
    { code: 'LOFENDRE', name: 'Loftus Dolphins SC' },
    { code: 'WLDXSCWX', name: 'Lomond SC' },
    { code: 'EWPLMDXL', name: 'London Bor of Enfield WPC' },
    { code: 'LHOLMDXL', name: 'London Borough of Hounslow' },
    { code: 'LBRLESXQ', name: 'London Borough of Redbridge SC' },
    { code: 'LODLMDXL', name: 'London Disability SC' },
    { code: 'LONLEASA', name: 'London Region' },
    { code: 'LRSLMDXL', name: 'London Regional Synchronised SC' },
    { code: 'LEDADRBA', name: 'Long Eaton SC' },
    { code: 'ELRXSEDX', name: 'Lothian Racers SC' },
    { code: 'LOGIEASA', name: 'Loughborough Performance Centre' },
    { code: 'LOUALECA', name: 'Loughborough Town SC' },
    { code: 'LCLALECA', name: 'Loughborough University Swimming' },
    { code: 'LOMTESXQ', name: 'Loughton Masters Swimming Club' },
    { code: 'LODALNCA', name: 'Louth Dolphins SC' },
    { code: 'LCMMWRCM', name: 'Lucton Typhoon SC' },
    { code: 'LUDMSHPM', name: 'Ludlow Swimming Club' },
    { code: 'LKDTBDFT', name: 'Luton Diving Club' },
    { code: 'LYDWGLUW', name: 'Lydney SC' },
    { code: 'YLSNLNCN', name: 'Lytham St Annes SC' },
    { code: 'MADSBSBS', name: 'Maidenhead ASC' },
    { code: 'MAISKNTQ', name: 'Maidstone SC' },
    { code: 'WMSXSCWX', name: 'Making Waves ASC' },
    { code: 'WENTESXQ', name: 'Maldon Sharks Swimming Club' },
    { code: 'MALWWLTW', name: 'Malmesbury Marlins ASC' },
    { code: 'MDCEYRKE', name: 'Maltby Diving Club' },
    { code: 'MNWNLNCN', name: 'Manchester & North West Disability SC' },
    { code: 'MADNLNCN', name: 'Manchester Aquatics Centre DC' },
    { code: 'MPONLNCN', name: 'Manchester Metropolitan University Swimming Club' },
    { code: 'MANIEASA', name: 'Manchester Performance Centre' },
    { code: 'MSWNLNCN', name: 'Manchester Sharks WPC' },
    { code: 'MTCNLNCN', name: 'Manchester TC Swimming Club' },
    { code: 'MANANTMA', name: 'Mansfield SC' },
    { code: 'MARTCMBT', name: 'March Marlins SC' },
    { code: 'NSHMSHPM', name: 'Market Drayton SC' },
    { code: 'MKHALECA', name: 'Market Harborough SC' },
    { code: 'MARWWLTW', name: 'Marlborough Penguins ASC' },
    { code: 'MPLNCHRN', name: 'Marple SC' },
    { code: 'MATADRBA', name: 'Matlock & District SC' },
    { code: 'MWPADRBA', name: 'Matlock Water Polo Club' },
    { code: 'MAXSONBS', name: 'Maxwell SC' },
    { code: 'MMSSKNTQ', name: 'Medway Artistic Swimming Club' },
    { code: 'MEMSKNTQ', name: 'Medway Maritime Swimming Club' },
    { code: 'MELWWLTW', name: 'Melksham ASC' },
    { code: 'MEMALECA', name: 'Melton Mowbray SC' },
    { code: 'MMLXSMDX', name: 'Menzieshill & Whitehall Swimming & WPC' },
    { code: 'WMMXSCWX', name: 'Merrick Mavericks SC' },
    { code: 'MERYEWAY', name: 'Merthyr Tydfil Swimming Club' },
    { code: 'MSDLSRYQ', name: 'Merton Sch of Diving & T' },
    { code: 'MERLSRYQ', name: 'Merton Swordfish SC' },
    { code: 'MTPLMDXL', name: 'Metropolitan Police SC' },
    { code: 'MSMSSSXS', name: 'Mid Sussex Marlins' },
    { code: 'MIDENDRE', name: 'Middlesbrough SC' },
    { code: 'MDXLMDXL', name: 'Middlesex County ASA' },
    { code: 'EMNXSEDX', name: 'Midlothian SC' },
    { code: 'MADTSFKT', name: 'Mildenhall & District SC' },
    { code: 'MILYWWAY', name: 'Milford Haven Swimming Club' },
    { code: 'MILWSMSW', name: 'Millfield' },
    { code: 'WMBXSCWX', name: 'Milngavie & Bearsden' },
    { code: 'MMSLSRYQ', name: 'Mitcham Marlins Swimming Club' },
    { code: 'MOLYNWAY', name: 'Mold Swimming Club' },
    { code: 'MMHXSMDX', name: 'Monifieth ASC' },
    { code: 'MONYEWAY', name: 'Monnow Swimming Club' },
    { code: 'MMSXSMDX', name: 'Montrose & District Seals ASC' },
    { code: 'MOOENDRE', name: 'Moors Swim Squad' },
    { code: 'NMYXSNDX', name: 'Moray Masters' },
    { code: 'MOREYRKE', name: 'Morley Swimming & WP Club' },
    { code: 'MOPENDRE', name: 'Morpeth SC' },
    { code: 'WMWXSCWX', name: 'Motherwell & Wishaw ASC' },
    { code: 'KELWDVNW', name: 'Mount Kelly Swimming' },
    { code: 'EMHXSEDX', name: 'Musselburgh ASC' },
    { code: 'NNNXSNDX', name: 'Nairn ASC' },
    { code: 'NNSXSNDX', name: 'Nairn Synchro SC' },
    { code: 'NANNCHRN', name: 'Nantwich Seals Swimming Club' },
    { code: 'NEAYWWAY', name: 'Neath Swimming Club' },
    { code: 'NEVANHPA', name: 'Nene Valley SC' },
    { code: 'NEPALECA', name: 'Neptune (Leicester) SC' },
    { code: 'NESNCHRN', name: 'Neston SC' },
    { code: 'NHSTESXQ', name: 'New Hall School Swim Club' },
    { code: 'NEWANTMA', name: 'Newark SC' },
    { code: 'NEWSBSBS', name: 'Newbury Swimming Club' },
    { code: 'NEWMSTFM', name: 'Newcastle (Staffs) ASC' },
    { code: 'NEWENDRE', name: 'Newcastle SwimTeam' },
    { code: 'NUELESXQ', name: 'Newham & University of East London (UEL) Swimming Club' },
    { code: 'NWMTSFKT', name: 'Newmarket & Dist SC' },
    { code: 'NADMSHPM', name: 'Newport & District SC' },
    { code: 'NPGSONBS', name: 'Newport Pagnell SC' },
    { code: 'NEQWCWLW', name: 'Newquay Cormorants SC' },
    { code: 'NQWWCWLW', name: 'Newquay Water Polo Club' },
    { code: 'NEWWDVNW', name: 'Newton Abbot Swimming and Water Polo Club' },
    { code: 'NLWNLNCN', name: 'Newton Le Willows SC' },
    { code: 'NWTYNWAY', name: 'Newtown Swimming Club' },
    { code: 'NTVYEWAY', name: 'Nexus Valleys Swimming Club' },
    { code: 'COLYNWAY', name: 'Nofio Bae Colwyn' },
    { code: 'NCPYNWAY', name: 'Nofio Clwyd' },
    { code: 'INDYEWAY', name: 'Nofio Cymru' },
    { code: 'SGPYNWAY', name: 'Nofio Gwynedd Performance' },
    { code: 'NSGYWWAY', name: 'Nofio Sir Gar' },
    { code: 'WNAXSCWX', name: 'North Ayrshire ASC' },
    { code: 'ENBXSEDX', name: 'North Berwick SC' },
    { code: 'NCDWCWLW', name: 'North Cornwall Dragons SC' },
    { code: 'NDTWDRSW', name: 'North Dorset Turbos SC' },
    { code: 'NEDENDRE', name: 'North East Disability Swim Club' },
    { code: 'UNLXSCCX', name: 'North Lanarkshire Swim Team' },
    { code: 'NLWLMDXL', name: 'North London Swimming & Water Polo Club' },
    { code: 'NNVTNRFT', name: 'North Norfolk Vikings SC' },
    { code: 'NTYENDRE', name: 'North Tyneside SC' },
    { code: 'NWAYWASA', name: 'North Wales Region' },
    { code: 'NTHNEASA', name: 'North West Region' },
    { code: 'NOREYRKE', name: 'Northallerton SC' },
    { code: 'NHNANHPA', name: 'Northampton Swimming Club' },
    { code: 'NWPANHPA', name: 'Northampton Water Polo Club' },
    { code: 'NHPANHPA', name: 'Northamptonshire ASA' },
    { code: 'NCEYNWAY', name: 'Northern Celts' },
    { code: 'NWMNLNCN', name: 'Northern Wave (Manchester) SC' },
    { code: 'NRHMSHPM', name: 'Northgate Bridgnorth SC' },
    { code: 'NDPENDRE', name: 'Northumberland & Durham Performance Programme SC' },
    { code: 'NDRENDRE', name: 'Northumberland and Durham' },
    { code: 'NTWNCHRN', name: 'Northwich Centurions SC' },
    { code: 'NORWSMSW', name: 'Norton-Radstock SC' },
    { code: 'NOSTNRFT', name: 'Norwich Swan SC' },
    { code: 'NSSTNRFT', name: 'Norwich Synchro Club' },
    { code: 'BRKTNRFT', name: 'Norwich WPC' },
    { code: 'LEAANTMA', name: 'Nottingham Leander SC' },
    { code: 'NORANTMA', name: 'Nottingham Northern SC' },
    { code: 'NPOANTMA', name: 'Nottingham Portland SC' },
    { code: 'NTMANTMA', name: 'Nottinghamshire ASA' },
    { code: 'NOVANTMA', name: 'Nova Centurion SC' },
    { code: 'NUNMWWKM', name: 'Nuneaton & Bedworth SC' },
    { code: 'OAWALECA', name: 'Oadby & Wigston SC' },
    { code: 'WOOXSCWX', name: 'Oban Otters SC' },
    { code: 'OKEWDVNW', name: 'Okehampton Otters SC' },
    { code: 'OWTLSRYQ', name: 'Old Whitgiftians SC' },
    { code: 'OLDNLNCN', name: 'Oldham SC' },
    { code: 'ORCNLNCN', name: 'ORCA (Royton)' },
    { code: 'ORIMWWKM', name: 'Orion SC' },
    { code: 'NOYXSNDX', name: 'Orkney ASC' },
    { code: 'ORMNLNCN', name: 'Ormskirk & District SC' },
    { code: 'OOJLKNTQ', name: 'Orpington Ojays' },
    { code: 'OSWMSHPM', name: 'Oswestry Otters SC' },
    { code: 'OTTLMDXL', name: 'Otter SC' },
    { code: 'OUTLMDXL', name: 'Out To Swim' },
    { code: 'OBPWDRSW', name: 'Out to Swim Bournemouth + Poole' },
    { code: 'OTBSSSXS', name: 'Out to Swim Brighton and Hove' },
    { code: 'OTBWGLUW', name: 'Out to Swim Bristol' },
    { code: 'OTSLMDXL', name: 'Out to Swim London' },
    { code: 'OTNENDRE', name: 'Out to Swim Newcastle' },
    { code: 'WDSSONBS', name: 'Oxford and Witney Artistic Swimming Club' },
    { code: 'OBSSONBS', name: 'Oxford Brookes University Swimming Club' },
    { code: 'OUSSONBS', name: 'Oxford University SC' },
    { code: 'OXUSONBS', name: 'Oxford University WPC' },
    { code: 'ONBSONBS', name: 'Oxfordshire & North Bucks ASA' },
    { code: 'PAIWDVNW', name: 'Paignton SC' },
    { code: 'EPSXSEDX', name: 'Peebles ASC' },
    { code: 'PEENLNCN', name: 'Peel Swimming Club (IOM)' },
    { code: 'PEMYWWAY', name: 'Pembroke & District Swimming Club' },
    { code: 'PCPYWWAY', name: 'Pembrokeshire County Swimming' },
    { code: 'PENYEWAY', name: 'Penarth Swimming and Water Polo Club' },
    { code: 'PTHNCUMN', name: 'Penrith SC' },
    { code: 'PEHYWWAY', name: 'Penyrheol Swimming Club' },
    { code: 'PENWCWLW', name: 'Penzance SA and WPC' },
    { code: 'PBEMWWKM', name: 'Perry Beeches Triple SSC' },
    { code: 'PESMWRCM', name: 'Pershore SC' },
    { code: 'MPCXSMDX', name: 'Perth City Swim Club' },
    { code: 'MPMXSMDX', name: 'Perth Masters' },
    { code: 'PSOTCMBT', name: 'Peterborough Special Olympic Swimming Group' },
    { code: 'NPDXSNDX', name: 'Peterhead ASC' },
    { code: 'PLCENDRE', name: 'Peterlee ASC' },
    { code: 'WPAXSCWX', name: 'Phoenix Aquatics' },
    { code: 'WPXXSCWX', name: 'Phoenix Aquatics Club' },
    { code: 'PCAWDVNW', name: 'Plymouth College Aquatics' },
    { code: 'PCDWDVNW', name: 'Plymouth Diving' },
    { code: 'PLYWDVNW', name: 'Plymouth Leander SC' },
    { code: 'PRNWDVNW', name: 'Plymouth Rn/Rm' },
    { code: 'PODEYRKE', name: 'Pocklington Dolphin SC' },
    { code: 'POLLMDXL', name: 'Polytechnic S&WP Club' },
    { code: 'PONEYRKE', name: 'Pontefract Marlins SC' },
    { code: 'POPYEWAY', name: 'Pontypridd Swimming Club' },
    { code: 'PBOWDRSW', name: 'Poole Bay Open Water Swimming Club' },
    { code: 'POOWDRSW', name: 'Poole SC' },
    { code: 'PTAYWWAY', name: 'Port Talbot Aquatics' },
    { code: 'PSHWSMSW', name: 'Portishead SC' },
    { code: 'EPOXSEDX', name: 'Portobello ASC' },
    { code: 'PDSSHNTS', name: 'Portsmouth & District Artistic Swimming Club' },
    { code: 'PCWSHNTS', name: 'Portsmouth City Waterpolo Club' },
    { code: 'PORSHNTS', name: 'Portsmouth Northsea SC' },
    { code: 'POVSHNTS', name: 'Portsmouth Victoria SC' },
    { code: 'PBSTHRTT', name: 'Potters Bar Artistic Swimming Club' },
    { code: 'POTTHRTT', name: 'Potters Bar SC' },
    { code: 'POYNCHRN', name: 'Poynton Dippers SC' },
    { code: 'PRENLNCN', name: 'Prescot Swimming Club' },
    { code: 'PRNNLNCN', name: 'Preston Swimming Club' },
    { code: 'PRCTBDFT', name: 'Putteridge Swimming Club' },
    { code: 'RADNLNCN', name: 'Radcliffe S&WPC' },
    { code: 'RADANTMA', name: 'Radford SC' },
    { code: 'RAMNLNCN', name: 'Ramsbottom SC' },
    { code: 'RSNNLNCN', name: 'Ramseian SC' },
    { code: 'RAMSKNTQ', name: 'Ramsgate SC' },
    { code: 'RNWSBSBS', name: 'Rari Nantes Waterpolo and Swimming (Slough)' },
    { code: 'RCYSBSBS', name: 'Reading Cygnets SC' },
    { code: 'RRSSBSBS', name: 'Reading Royals Artistic SC' },
    { code: 'REASBSBS', name: 'Reading SC' },
    { code: 'REDMWRCM', name: 'Redditch SC' },
    { code: 'RMASSRYQ', name: 'Redhill & Reigate Marlins' },
    { code: 'RERSSRYQ', name: 'Redhill & Reigate SC' },
    { code: 'RSCSSRYQ', name: 'Reed\'s Swimming Club (Cobham)' },
    { code: 'WRXXSCWX', name: 'Ren 96' },
    { code: 'WRBXSCWX', name: 'Renfrew Baths ASC' },
    { code: 'RESADRBA', name: 'Repton Swimming' },
    { code: 'RETANTMA', name: 'Retford SC' },
    { code: 'RCTYEWAY', name: 'Rhondda Cynon Taf Performance Swim Squad' },
    { code: 'RHOYEWAY', name: 'Rhondda Swimming Club' },
    { code: 'RHYYNWAY', name: 'Rhyl Dolphins Swimming Club' },
    { code: 'RICEYRKE', name: 'Richmond Dales ASC' },
    { code: 'RSCLSRYQ', name: 'Richmond Swimming Club' },
    { code: 'RICTHRTT', name: 'Rickmansworth Swim Club Ltd' },
    { code: 'RINSHNTS', name: 'Ringwood Seals Swimming Club' },
    { code: 'RIPADRBA', name: 'Ripley SC (rascals)' },
    { code: 'RCDNLNCN', name: 'Rochdale Swimming Club' },
    { code: 'RTSNLNCN', name: 'Rochdale Triathlon Swimming Club' },
    { code: 'ROCTESXQ', name: 'Rochford & District SC' },
    { code: 'ROMLESXQ', name: 'Romford Town SC' },
    { code: 'MARNCHRN', name: 'Romiley Marina Swimming Club' },
    { code: 'RMYSHNTS', name: 'Romsey & Totton SC' },
    { code: 'ROMEYRKE', name: 'Rotherham Metro SC' },
    { code: 'RMWEYRKE', name: 'Rotherham Metro Water Polo Club' },
    { code: 'ROTANHPA', name: 'Rothwell SC' },
    { code: 'RAFALNCA', name: 'Royal Air Force Swim Team' },
    { code: 'RNVSHNTS', name: 'Royal Navy Aquatics' },
    { code: 'RTMSKNTQ', name: 'Royal Tunbridge Wells Masters SC' },
    { code: 'RTWSKNTQ', name: 'Royal Tunbridge Wells Monson SC' },
    { code: 'WOBWWLTW', name: 'Royal Wootton Bassett ASC' },
    { code: 'RPMTHRTT', name: 'Royston Phoenix Masters' },
    { code: 'ROYTHRTT', name: 'Royston SC' },
    { code: 'RUGMWWKM', name: 'Rugby SC' },
    { code: 'RUILMDXL', name: 'Ruislip Northwood Masters SC' },
    { code: 'RRENCHRN', name: 'Runcorn Reps SC' },
    { code: 'RUNTESXQ', name: 'Runnymede SC' },
    { code: 'RSHANTMA', name: 'Rushcliffe SC' },
    { code: 'RUSANHPA', name: 'Rushden ASC' },
    { code: 'RUSSHNTS', name: 'Rushmoor Artistic SC' },
    { code: 'RURSHNTS', name: 'Rushmoor Royals SC' },
    { code: 'WRNXSCWX', name: 'Rutherglen ASC' },
    { code: 'RUTYNWAY', name: 'Ruthin Rays Swimming Club' },
    { code: 'RYDSHNTS', name: 'Ryde Swimming Club' },
    { code: 'RYEEYRKE', name: 'Ryedale SC' },
    { code: 'RYKADRBA', name: 'Rykneld SC' },
    { code: 'SADNLNCN', name: 'Saddleworth SC' },
    { code: 'SAFTESXQ', name: 'Saffron Walden SC' },
    { code: 'SACNLNCN', name: 'Salford City SC' },
    { code: 'SASWWLTW', name: 'Salisbury Stingrays SC' },
    { code: 'SALENDRE', name: 'Saltburn & Marske SC' },
    { code: 'SSHNCHRN', name: 'Sandbach Sharks SC' },
    { code: 'SAQMWRCM', name: 'Sandwell Aquatics Club' },
    { code: 'SDCMWRCM', name: 'Sandwell Diving Club' },
    { code: 'SATNCHRN', name: 'Satellite of Macclesfield SC' },
    { code: 'SAXLKNTQ', name: 'Saxon Crown (Lewisham) SC' },
    { code: 'SCAEYRKE', name: 'Scarborough Swimming Club' },
    { code: 'ESNXSEDX', name: 'Scorpion Swim Team' },
    { code: 'WSAXSCWX', name: 'Scotia ASC' },
    { code: 'SCCXSASA', name: 'Scotland Composite' },
    { code: 'SEDXSASA', name: 'Scotland East' },
    { code: 'SMDXSASA', name: 'Scotland Midland' },
    { code: 'SNDXSASA', name: 'Scotland North' },
    { code: 'SCWXSASA', name: 'Scotland West' },
    { code: 'LFMXSASA', name: 'Scottish ASA Life Member' },
    { code: 'USNXSASA', name: 'Scottish Non-Residential' },
    { code: 'USSXSCCX', name: 'Scottish Schools Swimming Assoc' },
    { code: 'SASASASA', name: 'Scottish Swimming' },
    { code: 'USWXSASA', name: 'Scottish Swimming Staff' },
    { code: 'SCNEYRKE', name: 'Scunthorpe Anchor SC' },
    { code: 'SEASHNTS', name: 'Seaclose Swimming Club' },
    { code: 'SEGWDRSW', name: 'Seagulls Swimming Club' },
    { code: 'ESYXSEDX', name: 'SEC Cyclones' },
    { code: 'SDGENDRE', name: 'Sedgefield & District 75' },
    { code: 'SDWENDRE', name: 'Sedgefield Water Polo Club' },
    { code: 'SELEYRKE', name: 'Selby Tigersharks Swimming Squad' },
    { code: 'SERLMDXL', name: 'Serpentine SC' },
    { code: 'SETEYRKE', name: 'Settle Stingrays SC' },
    { code: 'SEVSKNTQ', name: 'Sevenoaks SC' },
    { code: 'SSTWGLUW', name: 'Severnside Tritons Swimming Club' },
    { code: 'SSSLMDXL', name: 'Seymour Synchro Swim Sch' },
    { code: 'SMSYEWAY', name: 'Sharks Masters Swimming Club' },
    { code: 'SHKLKNTQ', name: 'Sharks SC of Mottingham' },
    { code: 'SHSSKNTQ', name: 'Sheerness SC & Lifeguard Corp' },
    { code: 'SHEEYRKE', name: 'Sheffield City SC' },
    { code: 'SHEALECA', name: 'Shepshed SC' },
    { code: 'SHESKNTQ', name: 'Shepway Swimming Club' },
    { code: 'SHRANTMA', name: 'Sherwood Colliery SC' },
    { code: 'SSDANTMA', name: 'Sherwood Seals Swimming Club' },
    { code: 'NSHXSNDX', name: 'Shetland ASC' },
    { code: 'NSTXSNDX', name: 'Shetland Masters' },
    { code: 'USDXSCCX', name: 'Shetland Swimming Association' },
    { code: 'SHWMSHPM', name: 'Shrewsbury SC' },
    { code: 'SHPMSHPM', name: 'Shropshire ASA' },
    { code: 'SIDWDVNW', name: 'Sid Vale SC' },
    { code: 'NSCXSNDX', name: 'Silver City Blues ASC' },
    { code: 'SAMSKNTQ', name: 'Sittingbourne & Milton SC' },
    { code: 'SKEALNCA', name: 'Skegness ASC' },
    { code: 'SKIEYRKE', name: 'Skipton Swimming Club' },
    { code: 'NSEXSNDX', name: 'Skye Dolphins ASC' },
    { code: 'SLESBSBS', name: 'Slough Dolphin Swimming Club' },
    { code: 'SCPSHNTS', name: 'Solent Cardinal Performance Swimming' },
    { code: 'SOLMWWKM', name: 'Solihull SC' },
    { code: 'SMSWSMSW', name: 'Somerset ASA' },
    { code: 'USAXSCCX', name: 'South Aberdeenshire Swim Team' },
    { code: 'SASEYRKE', name: 'South Axholme Sharks SC' },
    { code: 'WSEXSCWX', name: 'South Ayrshire ASC' },
    { code: 'SBMTBDFT', name: 'South Beds Masters Swimming Club' },
    { code: 'SCRLSRYQ', name: 'South Croydon SC' },
    { code: 'SDWADRBA', name: 'South Derbyshire Water Polo Club' },
    { code: 'SDTSHNTS', name: 'South Downs Trojan Swimming Club' },
    { code: 'SCTSEASA', name: 'South East Region' },
    { code: 'EWAYWASA', name: 'South East Wales Region' },
    { code: 'SHLEYRKE', name: 'South Holderness SC' },
    { code: 'SOHEYRKE', name: 'South Hunsley SC' },
    { code: 'USLXSCCX', name: 'South Lanarkshire Swimming' },
    { code: 'SLCALNCA', name: 'South Lincs Competitive SC' },
    { code: 'SLSLSRYQ', name: 'South London Open Water SC' },
    { code: 'NSMXSNDX', name: 'South Mainland ASC' },
    { code: 'STDENDRE', name: 'South Tyneside SC' },
    { code: 'SWDLSRYQ', name: 'South West London Diving Club' },
    { code: 'WSTWEASA', name: 'South West Region' },
    { code: 'WWAYWASA', name: 'South West Wales Region' },
    { code: 'SYSEYRKE', name: 'South Yorkshire Swans' },
    { code: 'SHMMWWKM', name: 'Southam SC' },
    { code: 'SDASHNTS', name: 'Southampton Diving Academy' },
    { code: 'USSSHNTS', name: 'Southampton University SC' },
    { code: 'SOTSHNTS', name: 'Southampton University WPC' },
    { code: 'SHWSHNTS', name: 'Southampton Water Polo Club' },
    { code: 'SEDTESXQ', name: 'Southend Diving' },
    { code: 'SOUNLNCN', name: 'Southern I-O-M SC' },
    { code: 'SPTNLNCN', name: 'Southport SC' },
    { code: 'SAQLSRYQ', name: 'Southwark Aquatics SC' },
    { code: 'SOUANTMA', name: 'Southwell SC' },
    { code: 'SWLLSRYQ', name: 'SouthWest LondonFin SC' },
    { code: 'SOTWGLUW', name: 'Southwold Swimming Club' },
    { code: 'SBLEYRKE', name: 'Sowerby Bridge Stingrays SC' },
    { code: 'SPDALNCA', name: 'Spalding SC' },
    { code: 'SPEEYRKE', name: 'Spenborough SC' },
    { code: 'SPELSRYQ', name: 'Spencer Swim Team' },
    { code: 'SAMTHRTT', name: 'St Albans Masters SC' },
    { code: 'ESAXSEDX', name: 'St Andrews Masters ASC' },
    { code: 'STAWCWLW', name: 'St Austell ASC' },
    { code: 'SGASBSBS', name: 'St George\'s Ascot Swimming Club' },
    { code: 'STHNLNCN', name: 'St Helens Swimming Club' },
    { code: 'SIVTCMBT', name: 'St Ives SC' },
    { code: 'SJALSRYQ', name: 'St James SC' },
    { code: 'SWNTCMBT', name: 'St Neots Swans Swimming Club' },
    { code: 'MASXSMDX', name: 'St Thomas ASC' },
    { code: 'APXMSTFM', name: 'Stafford Apex SC' },
    { code: 'STFMSTFM', name: 'Staffordshire ASA' },
    { code: 'STASMDXL', name: 'Staines Swimming Club' },
    { code: 'STANCHRN', name: 'Stalybridge SC' },
    { code: 'FSSTESXQ', name: 'Stanway SC' },
    { code: 'STCSSRYQ', name: 'Star Diving Club Guildford' },
    { code: 'ESRXSEDX', name: 'Step Rock ASC' },
    { code: 'STETHRTT', name: 'Stevenage SC' },
    { code: 'WSWXSCWX', name: 'Stirling Swimming' },
    { code: 'STXLMDXL', name: 'Stock Exchange SC' },
    { code: 'STMNCHRN', name: 'Stockport Metro SC' },
    { code: 'STONCHRN', name: 'Stockport SC' },
    { code: 'STOEYRKE', name: 'Stocksbridge Pentaqua SC' },
    { code: 'STKENDRE', name: 'Stockton ASC' },
    { code: 'STYENDRE', name: 'Stokesley SC' },
    { code: 'SADMSTFM', name: 'Stone & District SC' },
    { code: 'NSNXSNDX', name: 'Stonehaven ASC' },
    { code: 'SSSTBDFT', name: 'Stopsley Swim Squad' },
    { code: 'STRMWRCM', name: 'Stourbridge SC' },
    { code: 'STOTSFKT', name: 'Stowmarket SC' },
    { code: 'WSRXSCWX', name: 'Stranraer Stingrays ASC' },
    { code: 'SSHMWWKM', name: 'Stratford Sharks SC' },
    { code: 'WSCXSCWX', name: 'Strathclyde Aquatics' },
    { code: 'WSYXSCWX', name: 'Strathclyde University Swimming & WPC' },
    { code: 'STMLSRYQ', name: 'Streatham SC' },
    { code: 'STEWSMSW', name: 'Street & District SC' },
    { code: 'STRNLNCN', name: 'Stretford SC' },
    { code: 'STMWGLUW', name: 'Stroud Masters SC' },
    { code: 'SCOTSFKT', name: 'Suffolk Coastal Torpedoes' },
    { code: 'SCDENDRE', name: 'Sunderland City Dive Team' },
    { code: 'SUOSONBS', name: 'Sunflower Swimming Club - Oxford' },
    { code: 'SRYQSRYQ', name: 'Surrey County ASA' },
    { code: 'SSXSSSXS', name: 'Sussex County ASA' },
    { code: 'SUTLSRYQ', name: 'Sutton & Cheam SC' },
    { code: 'SUTANTMA', name: 'Sutton In Ashfield SC' },
    { code: 'SWAADRBA', name: 'Swadlincote SC' },
    { code: 'SSMYWWAY', name: 'Swansea Masters Swimming Club' },
    { code: 'SWDYWWAY', name: 'Swansea Stingrays Swimming Club' },
    { code: 'SUNYWWAY', name: 'Swansea University Swimming Team' },
    { code: 'SWPYWWAY', name: 'Swansea Water Polo' },
    { code: 'SBOWDRSW', name: 'Swim Bournemouth' },
    { code: 'SCPYNWAY', name: 'Swim Conwy' },
    { code: 'BDFTBDFT', name: 'Swim England Bedfordshire' },
    { code: 'CMBTCMBT', name: 'Swim England Cambridgeshire' },
    { code: 'SECQSECQ', name: 'Swim England County' },
    { code: 'ESXQESXQ', name: 'Swim England Essex' },
    { code: 'HRTTHRTT', name: 'Swim England Hertfordshire' },
    { code: 'NRFTNRFT', name: 'Swim England Norfolk' },
    { code: 'NECEEASA', name: 'Swim England North East Region' },
    { code: 'SERQEASA', name: 'Swim England Region' },
    { code: 'SFKTSFKT', name: 'Swim England Suffolk' },
    { code: 'SETQWWKM', name: 'Swim England Talent Club' },
    { code: 'SCCTSFKT', name: 'Swim Fore IT' },
    { code: 'WASAWASA', name: 'Swim Wales' },
    { code: 'UWLXSCCX', name: 'Swim West Lothian' },
    { code: 'NWIXSNDX', name: 'Swim Western Isles' },
    { code: 'ESIXSEDX', name: 'Swim-IT' },
    { code: 'ESCXSEDX', name: 'SwimClusion' },
    { code: 'SWAWWLTW', name: 'Swindon ASC' },
    { code: 'SWDWWLTW', name: 'Swindon Dolphin ASC' },
    { code: 'SWINLNCN', name: 'Swinton SC' },
    { code: 'TADEYRKE', name: 'Tadcaster York Sport Swim Squad' },
    { code: 'NTNXSNDX', name: 'Tain ASC' },
    { code: 'THSWDRSW', name: 'Talbot Heath School Swimming Club' },
    { code: 'TAMMSTFM', name: 'Tamworth SC' },
    { code: 'TASSSRYQ', name: 'Tandridge Aquarius Swim Squad' },
    { code: 'TASWSMSW', name: 'Taunton Artistic Swimming Club' },
    { code: 'TDSWSMSW', name: 'Taunton Deane SC' },
    { code: 'TAVWDVNW', name: 'Tavistock SC' },
    { code: 'MTMXSMDX', name: 'Tay Masters' },
    { code: 'TANTSFKT', name: 'Team Anglia Masters Swimming Club' },
    { code: 'TBSWSMSW', name: 'Team Bath Artistic Swimming Club' },
    { code: 'ASPWSMSW', name: 'Team Bath AS' },
    { code: 'TSEQEASA', name: 'Team England' },
    { code: 'YKVEYRKE', name: 'Team Jorvik and New Earswick SC - York Vikings' },
    { code: 'LUTTBDFT', name: 'Team Luton Swimming' },
    { code: 'TWSTSFKT', name: 'Team Waveney Swimming Club' },
    { code: 'IPSTSFKT', name: 'Teamipswich Swimming' },
    { code: 'TEDLMDXL', name: 'Teddington SC' },
    { code: 'TTOLMDXL', name: 'Teddington Torpedoes' },
    { code: 'TESENDRE', name: 'Teesdale ASC' },
    { code: 'TTSENDRE', name: 'Teesdale Tiger Sharks' },
    { code: 'TEIWDVNW', name: 'Teignmouth Swimming Club' },
    { code: 'TEAMSHPM', name: 'Telford Aqua' },
    { code: 'TENYWWAY', name: 'Tenby and District Swimming Club' },
    { code: 'TEWWGLUW', name: 'Tewkesbury SC' },
    { code: 'TAMSONBS', name: 'Thame Swimming Club' },
    { code: 'THASKNTQ', name: 'Thanet Swim Club' },
    { code: 'RSWMSTFM', name: 'The Royal School Wolverhampton Swimming' },
    { code: 'BIUMWWKM', name: 'The University Of Birmingham' },
    { code: 'THDTNRFT', name: 'Thetford Dolphins SC' },
    { code: 'TWHEYRKE', name: 'Thirsk White Horse Swim Team' },
    { code: 'THOENDRE', name: 'Thornaby SC' },
    { code: 'THUTESXQ', name: 'Thurrock Swimming Club' },
    { code: 'NTOXSNDX', name: 'Thurso ASC' },
    { code: 'SWCWWLTW', name: 'Tidworth Congers ASC' },
    { code: 'TIGSHNTS', name: 'Tigers SC (Jersey) Ltd' },
    { code: 'THAWWLTW', name: 'Tigersharks' },
    { code: 'TILSBSBS', name: 'Tilehurst SC' },
    { code: 'TIVWDVNW', name: 'Tiverton SC' },
    { code: 'TIWWDVNW', name: 'Tiverton Water Polo Club' },
    { code: 'TONSKNTQ', name: 'Tonbridge SC' },
    { code: 'TDOYEWAY', name: 'Torfaen Dolphins Performance' },
    { code: 'TQLWDVNW', name: 'Torquay Leander SC' },
    { code: 'TORWDVNW', name: 'Torridgeside SC' },
    { code: 'TOTWDVNW', name: 'Totnes SC' },
    { code: 'TOWLMDXL', name: 'Tower Hamlets SC' },
    { code: 'TSSNCHRN', name: 'Trafford Artistic Swimming Club' },
    { code: 'TMBNCHRN', name: 'Trafford Metro Bor SC' },
    { code: 'ETTXSEDX', name: 'Tranent ASC' },
    { code: 'TPSMSTFM', name: 'Transplant Swimming UK SC' },
    { code: 'TREYEWAY', name: 'Tredegar Torpedoes Swimming Club' },
    { code: 'CHAWSMSW', name: 'Trident Swimming Club of East Devon, West Dorset and South Somerset' },
    { code: 'TRITHRTT', name: 'Tring Swimming Club' },
    { code: 'ETNXSEDX', name: 'Trojan ASC' },
    { code: 'TROWWLTW', name: 'Trowbridge ASC' },
    { code: 'TRUWCWLW', name: 'Truro City SC Ltd' },
    { code: 'TGLMWWKM', name: 'Tudor Grange Learn to Dive' },
    { code: 'TWDSKNTQ', name: 'Tunbridge Wells Diving Club' },
    { code: 'TURLKNTQ', name: 'Turtles Of South London SC' },
    { code: 'TYLNLNCN', name: 'Tyldesley Swimming Club' },
    { code: 'TYNENDRE', name: 'Tynedale SC' },
    { code: 'TDCENDRE', name: 'Tynemouth Diving Club' },
    { code: 'TYMENDRE', name: 'Tynemouth SC' },
    { code: 'NULXSNDX', name: 'Ullapool Swimming Club' },
    { code: 'ULVNCUMN', name: 'Ulverston SC' },
    { code: 'UNAXSASA', name: 'Unattached' },
    { code: 'NUAXSNDX', name: 'University of Aberdeen Performance Swimming' },
    { code: 'BAUWSMSW', name: 'University of Bath SC' },
    { code: 'UEATNRFT', name: 'University of East Anglia Swimming & Water Polo Club' },
    { code: 'UMANLNCN', name: 'University of Manchester Swimming Club' },
    { code: 'UONANTMA', name: 'University of Nottingham SC' },
    { code: 'WUSXSCWX', name: 'University Of Stirling' },
    { code: 'WSUXSCWX', name: 'University of Stirling Water Polo Club' },
    { code: 'SUNSSRYQ', name: 'University of Surrey Swimming Club' },
    { code: 'NUDXSNDX', name: 'Upper Deeside ASC' },
    { code: 'VERTHRTT', name: 'Verulam ASC' },
    { code: 'WVSXSCWX', name: 'Visions Swim Academy' },
    { code: 'WALNCHRN', name: 'Wallasey SC' },
    { code: 'WASMSTFM', name: 'Walsall Artistic Swimming Club' },
    { code: 'WLTMSTFM', name: 'Walsall Learn to Dive' },
    { code: 'WALMSTFM', name: 'Walsall Swim and Water Polo Club' },
    { code: 'WFDLESXQ', name: 'Waltham Forest Diving Club' },
    { code: 'WANLSRYQ', name: 'Wandsworth SC' },
    { code: 'WWWSONBS', name: 'Wantage White Horses' },
    { code: 'WAYSONBS', name: 'Wantage Youth SC' },
    { code: 'WARTHRTT', name: 'Ware SC' },
    { code: 'WARWDRSW', name: 'Wareham & District SC' },
    { code: 'WAMWWLTW', name: 'Warminster & District ASC' },
    { code: 'EWBXSEDX', name: 'Warrender Baths Club' },
    { code: 'WMSNCHRN', name: 'Warrington Masters Swimming Club' },
    { code: 'WARNCHRN', name: 'Warrington Swimming Club' },
    { code: 'WOWNCHRN', name: 'Warrington Warriors SC' },
    { code: 'WAUMWWKM', name: 'Warwick University SC' },
    { code: 'WARMWWKM', name: 'Warwick Water Polo Club' },
    { code: 'WWKMWWKM', name: 'Warwickshire ASA' },
    { code: 'WATTHRTT', name: 'Watford SC' },
    { code: 'WPOTHRTT', name: 'Watford Water Polo Club' },
    { code: 'WEVENDRE', name: 'Wear Valley SC' },
    { code: 'WELANHPA', name: 'Wellingborough SC' },
    { code: 'WLNWSMSW', name: 'Wellington' },
    { code: 'WTNMSHPM', name: 'Wellington (Telford) SC' },
    { code: 'WELWSMSW', name: 'Wells Swimming Club' },
    { code: 'WWPYEWAY', name: 'Welsh Wanderers Water Polo Club' },
    { code: 'WELYNWAY', name: 'Welshpool Sharks Swimming Club' },
    { code: 'WELTHRTT', name: 'Welwyn Garden SC' },
    { code: 'WDOWDRSW', name: 'West Dorset SC' },
    { code: 'WDDXSCWX', name: 'West Dunbartonshire ASC' },
    { code: 'EWEXSEDX', name: 'West Edinburgh Stingrays' },
    { code: 'WEKNCHRN', name: 'West Kirby ASC' },
    { code: 'HAPLMDXL', name: 'West London Penguin Swimming & Water Polo Club' },
    { code: 'WESMEASA', name: 'West Midland Region' },
    { code: 'KLWTNRFT', name: 'West Norfolk Swimming Club' },
    { code: 'WSUTSFKT', name: 'West Suffolk Swimming Club' },
    { code: 'WEWSHNTS', name: 'West Wight SC' },
    { code: 'WWDWWLTW', name: 'West Wilts Diving Club' },
    { code: 'WESWWLTW', name: 'Westbury ASC' },
    { code: 'WABXSCWX', name: 'Western Baths WPC' },
    { code: 'NWDXSNDX', name: 'Westhill District ASC' },
    { code: 'WTILMDXL', name: 'Westminster Tiburones SC' },
    { code: 'WSMWSMSW', name: 'Weston-Super-Mare SC' },
    { code: 'NWSXSNDX', name: 'Westside Sharks Swimming Club' },
    { code: 'WETEYRKE', name: 'Wetherby SC' },
    { code: 'WEYSSRYQ', name: 'Wey Valley SC' },
    { code: 'WPWWDRSW', name: 'Weymouth & Portland WPC' },
    { code: 'WEYWDRSW', name: 'Weymouth SC' },
    { code: 'WEOWDRSW', name: 'Weyport Masters SC' },
    { code: 'NWYXSNDX', name: 'Whalsay ASC' },
    { code: 'WHTEYRKE', name: 'Whitby Seals SC' },
    { code: 'WHTMSHPM', name: 'Whitchurch Wasps Swimming Club' },
    { code: 'WCDSKNTQ', name: 'White Cliffs (of Dover) Swimming Club' },
    { code: 'WHISKNTQ', name: 'White Oak SC' },
    { code: 'WHSLSRYQ', name: 'Whitgift Swimming Club' },
    { code: 'WSCTCMBT', name: 'Whittlesey SC' },
    { code: 'NWKXSNDX', name: 'Wick ASC' },
    { code: 'WBENLNCN', name: 'Wigan Best SC' },
    { code: 'WIGNLNCN', name: 'Wigan SC' },
    { code: 'WWASHNTS', name: 'Wildern Waves' },
    { code: 'WRSLMDXL', name: 'Willesden Rapids Swimming Club' },
    { code: 'WILNCHRN', name: 'Wilmslow & District ASC' },
    { code: 'WLTWWLTW', name: 'Wiltshire ASA' },
    { code: 'WMBLSRYQ', name: 'Wimbledon Dolphins SC' },
    { code: 'WINWSMSW', name: 'Wincanton SC' },
    { code: 'WCPSHNTS', name: 'Winchester City Penguins' },
    { code: 'WIWSHNTS', name: 'Winchester Water Polo Club' },
    { code: 'WMSSBSBS', name: 'Windsor & Maidenhead StarFish SC' },
    { code: 'WINSBSBS', name: 'Windsor SC' },
    { code: 'WINNCHRN', name: 'Winsford Swimming Club' },
    { code: 'WIMNCHRN', name: 'Wirral Metro SC' },
    { code: 'WISTCMBT', name: 'Wisbech Swimming Club' },
    { code: 'WITTESXQ', name: 'Witham Dolphins SC' },
    { code: 'WITNLNCN', name: 'Withnell SC' },
    { code: 'WITSONBS', name: 'Witney & District SC' },
    { code: 'WWPSONBS', name: 'Witney Water Polo Club' },
    { code: 'WOKSSRYQ', name: 'Woking SC' },
    { code: 'WLVMSTFM', name: 'Wolverhampton SC' },
    { code: 'WOMMSTFM', name: 'Wombourne SC' },
    { code: 'WOONCHRN', name: 'Woodchurch SC' },
    { code: 'WOSALNCA', name: 'Woodhall Sharks SC' },
    { code: 'WOFTESXQ', name: 'Woodham Ferrers Swimming Club' },
    { code: 'WOOLSRYQ', name: 'Woodside & Thornton Heath SC' },
    { code: 'WSCNLNCN', name: 'Woolton SC' },
    { code: 'WRCMWRCM', name: 'Worcester County ASA' },
    { code: 'WCRMWRCM', name: 'Worcester Crocodiles' },
    { code: 'WORMWRCM', name: 'Worcester SC' },
    { code: 'WORNCUMN', name: 'Workington SC' },
    { code: 'WOKANTMA', name: 'Worksop Dolphins SC' },
    { code: 'WORSSSXS', name: 'Worthing Swimming Club' },
    { code: 'WCOMSHPM', name: 'Wrekin SC' },
    { code: 'WREYNWAY', name: 'Wrexham Swimming Club' },
    { code: 'WRWYNWAY', name: 'Wrexham Water Polo' },
    { code: 'WYCSBSBS', name: 'Wycombe District SC' },
    { code: 'WLDMWWKM', name: 'Wyndley Learn to Dive' },
    { code: 'WYRMWRCM', name: 'Wyre Forest SC' },
    { code: 'WYTNCHRN', name: 'Wythenshawe SC' },
    { code: 'MYAXSMDX', name: 'Y.A.A.B.A ASC' },
    { code: 'YEOWSMSW', name: 'Yeovil District SC' },
    { code: 'YCBEYRKE', name: 'York City Baths Club' },
    { code: 'YRKEYRKE', name: 'Yorkshire AS' },
    { code: 'NYNXSNDX', name: 'Ythan ASC' },
];
export function detectClubCode(clubName) {
    if (!clubName)
        return undefined;
    const lower = clubName.toLowerCase();
    // Exact match first
    const exact = CLUBS.find(c => c.name.toLowerCase() === lower);
    if (exact)
        return exact.code;
    // DB name starts with swimmer's club name (e.g. "Beckenham" matches "Beckenham SC")
    const prefixMatch = CLUBS.find(c => c.name.toLowerCase().startsWith(lower));
    if (prefixMatch)
        return prefixMatch.code;
    // Swimmer's club name starts with DB name (reverse prefix)
    const reverseMatch = CLUBS.find(c => lower.startsWith(c.name.toLowerCase()));
    if (reverseMatch)
        return reverseMatch.code;
    return undefined;
}
// Last 4 chars of the 8-char club code are the county code
export function getCountyCodeForClub(clubName) {
    return detectClubCode(clubName)?.slice(4);
}
import { getRegionCodeFromCountyCode } from './counties';
// Within Kent (KNTQ) and Surrey (SRYQ), the 4th character of the 8-char club code
// encodes sub-association: 'L' = London sub-association, 'S' = county proper.
// e.g. BEKLKNTQ (Beckenham) → London; DARSKNTQ (Dartford) → Kent.
const LONDON_BORDER_COUNTIES = new Set(['KNTQ', 'SRYQ', 'ESXQ']);
// Clubs coded London-region that don't follow the 'L' convention (e.g. historical mis-coding).
const LONDON_REGION_EXCEPTIONS = new Set(['CAWSSRYQ']);
export function getRegionCodeForClub(clubName) {
    const clubCode = detectClubCode(clubName);
    if (!clubCode)
        return undefined;
    const countyCode = clubCode.slice(4);
    if (LONDON_REGION_EXCEPTIONS.has(clubCode) || (clubCode[3] === 'L' && LONDON_BORDER_COUNTIES.has(countyCode))) {
        return 'L';
    }
    return getRegionCodeFromCountyCode(countyCode);
}
